import React from 'react';
import { Row, Col, Input, Spinner, Alert, Tooltip, Table, Modal, ModalBody, ModalFooter, Label } from 'reactstrap';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faHistory } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import _ from 'lodash';
import { datesFormat } from '../../config';
import Translate, { t } from '../common/Translate';
import useCoverageRequest from '../../hooks/usePricing/useCoverageRequest';
import '../../assets/scss/react-datepicker.css';
import OffersTable from './OffersTable';
import SaleStatusTag from './SaleStatusTag';
import { Auth } from '../../config/configuration/react';

const CoverageRequest = () => {
  const { recordId } = useParams();
  const {
    display,
    offers,
    inputs,
    showPartner,
    allowNewCouverage,
    isSubmitLoading,
    isSubmitError,
    isOfferLoading,
    apiErrorMessage,
    dateFormat,
    toggle,
    isOpen,
    tooltipOpen,
    openInfoBull,
    countDown,
    showCountDown,
    dispatch,
    saleInfo,
    showHistory,
    showPartnerVpAuto,
    showPartnerEncheresVo,
    showParnterAlcopa,
    showPartnerMercier,
    buttonRef,
    errorDate,
    body,
    setBody,
    selectedDate,
    selectedTime,
    setIsOpen,
    handleCreate,
    cancelAlcopa,
    vehicle,
    partnerBody,
  } = useCoverageRequest(recordId);
  const { id: saleId, sale_purchase_order: purchaseOrder, sale_status: saleStatusInfo } = saleInfo;
  const saleStatus = saleStatusInfo?.name;
  const {
    alert,
    title,
    clientPrice,
    commentCoverageRequest,
    create,
    newCouverageBtn,
    commentPartnerRequest,
    userGroup,
    endDate,
    endTime,
  } = inputs;
  const vpauto = offers.filter((partner) => partner.partnerName === 'partnerVpauto');
  const encheresVo = offers.filter((partner) => partner.partnerName === 'encheresvo');
  const alcopa = offers.filter((partner) => partner.partnerName === 'alcopa');
  const mercier = offers.filter((partner) => partner.partnerName === 'mercier');
  const autobizTrade = offers.filter(
    (partner) =>
      partner.partnerName !== 'partnerVpauto' &&
      partner.partnerName !== 'encheresvo' &&
      partner.partnerName !== 'alcopa' &&
      partner.partnerName !== 'mercier',
  );
  const supOfferId = _.maxBy([...offers], (o) => o.value)?.id || null;
  const appLang = Auth.preferredLanguage();

  return (
    <>
      <div className="page-coverage">
        {alert.coverageIdAlreadyExits.show && (
          <Alert color="secondary" className="mt-n3">
            {alert.coverageIdAlreadyExits.label}
          </Alert>
        )}
        <Row className="block-coverage mt-3">
          <Col xs="12" sm="12" md="12" lg="4">
            {display && (
              <>
                <Row>
                  <Col xs="12" sm="12" lg="12" xl="12">
                    <Row className="pb-3">
                      <Col xs="10" sm="10" lg="10" xl="10">
                        <InfoBullItem
                          tooltipOpen={tooltipOpen.first}
                          id="Tooltip-first"
                          openInfoBull={() => openInfoBull('first')}
                          message="coverageRequestInfo1"
                        />
                        <font className="text-primary text-left text-bold pl-2" size="3">
                          {title}:
                        </font>
                      </Col>
                      <Col className="checkbox">
                        <Input
                          checked={inputs.privateRequest.checked}
                          id={inputs.privateRequest.id}
                          type="checkbox"
                          disabled={inputs.privateRequest.disabled}
                          onChange={inputs.privateRequest.onChange}
                        />
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <Col>
                        {userGroup.show && (
                          <Select
                            id="damage"
                            className="rounded"
                            value={userGroup.value}
                            options={userGroup.options}
                            placeholder={userGroup.placeholder}
                            onChange={(selectedOptions) =>
                              userGroup.setValue(selectedOptions ? selectedOptions.map((opt) => opt.value) : [])
                            }
                            data-cy="damages"
                            isDisabled={userGroup.disable}
                            isSearchable={false}
                            isMulti
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className="pb-1">
                      <Col xs="12">
                        <Label className="text-primary text-left" for="endDate">
                          <Translate code="endDate" />
                        </Label>
                        <DatePicker
                          name="endDate"
                          id="endDate"
                          disabled={endDate.disabled}
                          className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                          onChange={(e) => {
                            setBody({
                              ...body,
                              endDate: moment(e).format('YYYY-MM-DD'),
                            });
                          }}
                          selected={selectedDate}
                          dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                          placeholderText={t('long_date_placeholder')}
                          autoComplete="off"
                        />
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <Col xs="12">
                        <Label className="text-primary text-left" for="endTime">
                          <Translate code="endTime" />
                        </Label>
                        <input
                          type="time"
                          id="endTime"
                          name="endTime"
                          disabled={endTime.disabled}
                          className={errorDate === true ? 'form-control rounded error' : 'form-control rounded'}
                          value={selectedTime}
                          onChange={(e) => {
                            let value;
                            if (e.target.value) {
                              value = e.target.value;
                            } else {
                              value = null;
                            }
                            setBody({
                              ...body,
                              endTime: value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <Col>
                        <InfoBullItem
                          tooltipOpen={tooltipOpen.fifth}
                          id="Tooltip-fifth"
                          openInfoBull={() => openInfoBull('fifth')}
                          message="infoDesiredPrice"
                        />
                        <font className="text-primary text-left text-bold pl-2" size="3">
                          {clientPrice.label}
                        </font>
                        <div className="input-finalPrice">
                          <Input
                            className="rounded mr-3"
                            type="number"
                            name="clientPrice"
                            id="clientPrice"
                            min="0"
                            disabled={clientPrice.disabled}
                            onChange={clientPrice.onchange}
                            value={Number.isNaN(clientPrice.value) ? '' : clientPrice.value}
                          />
                          <span>
                            <Translate code="€ TTC" />
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <Col>
                        <InfoBullItem
                          tooltipOpen={tooltipOpen.third}
                          id="Tooltip-third"
                          openInfoBull={() => openInfoBull('third')}
                          message="coverageRequestInfo3"
                        />
                        <font className="text-primary text-left text-bold pl-2" size="3">
                          {commentCoverageRequest.label}
                        </font>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Input
                          value={commentCoverageRequest.value}
                          type="textarea"
                          name={commentCoverageRequest.id}
                          id={commentCoverageRequest.id}
                          disabled={commentCoverageRequest.disabled}
                          className="rounded"
                          onChange={commentCoverageRequest.onChange}
                        />
                      </Col>
                    </Row>
                    {showPartner && (
                      <>
                        <Row className="pb-3">
                          <Col>
                            <InfoBullItem
                              tooltipOpen={tooltipOpen.second}
                              id="Tooltip-second"
                              openInfoBull={() => openInfoBull('second')}
                              message="coverageRequestInfo2"
                            />
                            <font className="text-primary text-left text-bold pl-2" size="3">
                              {inputs.partnerRequest.label} :
                            </font>
                          </Col>
                        </Row>
                        {showPartnerVpAuto && (
                          <Row className="pl-4 pb-3">
                            <Col xs="10" sm="10" lg="10" xl="10">
                              <span className="text-primary">{inputs.partnerRequest.vpauto.label}</span>
                            </Col>
                            <Col className="checkbox">
                              <Input
                                checked={inputs.partnerRequest.vpauto.checked}
                                id={inputs.partnerRequest.vpauto.id}
                                type="checkbox"
                                disabled={inputs.partnerRequest.vpauto.disabled}
                                onChange={inputs.partnerRequest.vpauto.onChange}
                              />
                            </Col>
                          </Row>
                        )}
                        {showPartnerEncheresVo && (
                          <Row className="pl-4 pb-3">
                            <Col xs="10" sm="10" lg="10" xl="10">
                              <span className="text-primary">{inputs.partnerRequest.encheresVo.label}</span>
                            </Col>
                            <Col className="checkbox">
                              <Input
                                checked={inputs.partnerRequest.encheresVo.checked}
                                id={inputs.partnerRequest.encheresVo.id}
                                type="checkbox"
                                disabled={inputs.partnerRequest.encheresVo.disabled}
                                onChange={inputs.partnerRequest.encheresVo.onChange}
                              />
                            </Col>
                          </Row>
                        )}
                        {showParnterAlcopa && (
                          <Row className="pl-4 pb-3">
                            <Col xs="10" sm="10" lg="10" xl="10">
                              <span className="text-primary">{inputs.partnerRequest.alcopa.label}</span>
                            </Col>
                            <Col className="checkbox">
                              <Input
                                checked={inputs.partnerRequest.alcopa.checked}
                                id={inputs.partnerRequest.alcopa.id}
                                type="checkbox"
                                disabled={inputs.partnerRequest.alcopa.disabled}
                                onChange={inputs.partnerRequest.alcopa.onChange}
                              />
                            </Col>
                          </Row>
                        )}
                        {showPartnerMercier && (
                          <Row className="pl-4 pb-3">
                            <Col xs="10" sm="10" lg="10" xl="10">
                              <span className="text-primary">{inputs.partnerRequest.mercier.label}</span>
                            </Col>
                            <Col className="checkbox">
                              <Input
                                checked={inputs.partnerRequest.mercier.checked}
                                id={inputs.partnerRequest.mercier.id}
                                type="checkbox"
                                disabled={inputs.partnerRequest.mercier.disabled}
                                onChange={inputs.partnerRequest.mercier.onChange}
                              />
                            </Col>
                          </Row>
                        )}
                        {/* <Row className="pl-3">
                      <Col>
                        <span className="text-primary">{t("alcopa")}</span>
                      </Col>
                      <Col className="checkbox">
                        <Input
                          checked={partnerBody.alcopa}
                          id="alcopa"
                          type="checkbox"
                          className="checkbox"
                          disabled={allowNewCouverage}
                          onChange={(e) =>
                            setPartnerBody({
                              ...partnerBody,
                              alcopa: e.target.checked,
                            })
                          }
                        />
                      </Col>
                    </Row> */}
                        <Row className="pb-3">
                          <Col>
                            <InfoBullItem
                              tooltipOpen={tooltipOpen.fourth}
                              id="Tooltip-fourth"
                              openInfoBull={() => openInfoBull('fourth')}
                              message="coverageRequestInfo4"
                            />
                            <font className="text-primary text-left text-bold pl-2" size="3">
                              {commentPartnerRequest.label}
                            </font>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Input
                              value={commentPartnerRequest.value}
                              type="textarea"
                              name={commentPartnerRequest.id}
                              id={commentPartnerRequest.id}
                              disabled={commentPartnerRequest.disabled}
                              className="rounded"
                              onChange={commentPartnerRequest.onChange}
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    {(allowNewCouverage && (
                      <Row>
                        <Col>
                          <button type="submit" className="btn btn-1 btn-block" onClick={newCouverageBtn.onClick}>
                            {newCouverageBtn.label}
                          </button>
                        </Col>
                      </Row>
                    )) || (
                      <Row>
                        <Col>
                          <button
                            type="submit"
                            className={`btn btn-block ${errorDate || create.disabled ? 'btn-4' : 'btn-1'}`}
                            onClick={() => {
                              if (_.some(partnerBody, (value) => value === true) && !vehicle.versionId) {
                                setIsOpen({ selectedVersion: true });
                              } else if (
                                inputs.partnerRequest.alcopa.checked ||
                                inputs.partnerRequest.mercier.checked
                              ) {
                                setIsOpen({ alcopa: true });
                              } else {
                                create.onClick();
                              }
                            }}
                            disabled={create.disabled || errorDate}
                            ref={buttonRef}
                          >
                            {create.label}
                            {isSubmitLoading && <Spinner size="sm" />}
                          </button>
                          {isSubmitError && (
                            <p className="ml-2 text-danger">
                              <Translate code={isSubmitError} />
                            </p>
                          )}
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </Col>
          {showHistory && (
            <Col xs="12" sm="12" md="5" lg="2" className="pb-3">
              <button
                type="button"
                className="btn btn-block btn-3 custom-padding subtitle"
                onClick={() => toggle('history')}
              >
                <FontAwesomeIcon icon={faHistory} />
                <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">{t('historyCoverageRequest')}</span>
              </button>
            </Col>
          )}
        </Row>

        {isOfferLoading && (
          <div className="ml-2">
            <Translate code="coverageRequestPending" /> ...
            <Spinner type="grow" color="primary" />
          </div>
        )}
        {apiErrorMessage && (
          <Row>
            <Col xs="12" sm="6" lg="5" xl="4">
              <p>{apiErrorMessage}</p>
            </Col>
          </Row>
        )}
        {saleStatus && (
          <div className="mt-5">
            <SaleStatusTag status={saleStatus} />
            {showCountDown && <span className="ml-4 countdown-sale font-weight-bold">{countDown}</span>}
          </div>
        )}
        {offers.length > 0 && (
          <>
            <Row className="pl-2 mt-5 mb-5">
              <Col>
                <font className="text-primary text-left mr-5 text-bold" size="3">
                  <Translate code="offerCoverageRequest" />
                </font>
                <button
                  type="button"
                  outline="true"
                  className="btn btn-3 mb-2 btn-refresh"
                  onClick={inputs.refresh.onclick}
                >
                  {inputs.refresh.label}
                </button>
              </Col>
            </Row>
          </>
        )}
        {autobizTrade.length > 0 && (
          <>
            <div className="offer-title">
              <span className="logo logo-autobiz">autobiz</span>
              <span className="logo logo-trade">Trade</span>
            </div>
            <OffersTable
              data={autobizTrade}
              dateFormat={dateFormat}
              saleStatus={saleStatus}
              saleId={saleId}
              dispatch={dispatch}
              recordId={recordId}
              isOfferLoading={isOfferLoading}
              supOfferId={supOfferId}
              purchaseOrder={purchaseOrder}
              offers={offers}
            />
            <br />
          </>
        )}
        {vpauto.length > 0 && (
          <>
            <span className="offer-title">VP AUTO</span>
            <OffersTable
              data={vpauto}
              showPartner={showPartner}
              dateFormat={dateFormat}
              saleStatus={saleStatus}
              saleId={saleId}
              dispatch={dispatch}
              recordId={recordId}
              isOfferLoading={isOfferLoading}
              supOfferId={supOfferId}
              partnerName="vpauto"
              offers={offers}
              purchaseOrder={purchaseOrder}
            />
            <br />
          </>
        )}
        {encheresVo.length > 0 && (
          <>
            <span className="offer-title">ENCHÈRES VO</span>
            <OffersTable
              data={encheresVo}
              showPartner={showPartner}
              dateFormat={dateFormat}
              saleStatus={saleStatus}
              saleId={saleId}
              dispatch={dispatch}
              recordId={recordId}
              isOfferLoading={isOfferLoading}
              supOfferId={supOfferId}
              partnerName="encheresvo"
              offers={offers}
              purchaseOrder={purchaseOrder}
            />
            <br />
          </>
        )}
        {alcopa.length > 0 && (
          <>
            <span className="offer-title">Alcopa</span>
            <OffersTable
              data={alcopa}
              showPartner={showPartner}
              dateFormat={dateFormat}
              saleStatus={saleStatus}
              saleId={saleId}
              dispatch={dispatch}
              recordId={recordId}
              isOfferLoading={isOfferLoading}
              supOfferId={supOfferId}
              partnerName="alcopa"
              offers={offers}
              purchaseOrder={purchaseOrder}
            />
            <br />
          </>
        )}
        {mercier.length > 0 && (
          <>
            <span className="offer-title">{t('partnerMercier')}</span>
            <OffersTable
              data={mercier}
              showPartner={showPartner}
              dateFormat={dateFormat}
              saleStatus={saleStatus}
              saleId={saleId}
              dispatch={dispatch}
              recordId={recordId}
              isOfferLoading={isOfferLoading}
              supOfferId={supOfferId}
              partnerName="mercier"
              offers={offers}
              purchaseOrder={purchaseOrder}
            />
            <br />
          </>
        )}
      </div>
      <GroupListModel isOpen={!!isOpen.group} toggle={() => toggle('group')} />
      <HistoryModel
        isOpen={!!isOpen.history}
        toggle={() => toggle('history')}
        saleInfo={saleInfo}
        offers={offers}
        dateFormat={dateFormat}
      />
      <AlcopaModal
        isOpen={!!isOpen.alcopa}
        toggle={() => toggle('alcopa')}
        handleCreate={handleCreate}
        cancelAlcopa={cancelAlcopa}
      />
      <NoSelectedVersionAuctionnerModal
        isOpen={!!isOpen.selectedVersion}
        toggle={() => toggle('selectedVersion')}
        cancel={() => toggle('selectedVersion')}
      />
    </>
  );
};

export default CoverageRequest;

const HistoryModel = ({ isOpen, toggle, saleInfo, offers, dateFormat }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal-lg">
      <ModalBody className="pb-0">
        <h2>{t('historyCoverageRequest')}</h2>
        <Table hover responsive="sm">
          <thead>
            <tr>
              <td>{t('dateHourHistory')}</td>
              <td>{t('merchantInfos')}</td>
              <td>{t('infosCoverage')}</td>
            </tr>
          </thead>
          <tbody>
            {Object.keys(saleInfo).length > 0 && (
              <tr>
                <td className="border-dark border-bottom">
                  {saleInfo?.start_date_time && moment(saleInfo?.start_date_time).format(dateFormat)}
                </td>
                <td className="border-dark border-bottom">
                  {(saleInfo?.ownerUserName && saleInfo?.ownerUserName) || '-'}
                </td>
                <td className="border-dark border-bottom">
                  <span>
                    {`${t('groupAt')} : ${(saleInfo?.group?.name && saleInfo?.group?.name) || '-'}`}
                    <br />
                  </span>
                  <span>{`${t('commentSupBuy')} : ${(saleInfo?.comment && saleInfo?.comment) || '-'}`}</span>
                </td>
              </tr>
            )}
            {offers.length > 0 &&
              offers.map((i) => {
                if (i.partnerName === 'vpauto') {
                  return (
                    <tr key={i.id}>
                      <td>{i.createdAt && moment(i.createdAt).format(dateFormat)}</td>
                      <td>{(i.ownerUserName && i.ownerUserName) || '-'}</td>
                      <td>
                        <span>
                          {`${t('groupAt')} : ${(i?.partnerName && i?.partnerName) || '-'}`}
                          <br />
                        </span>
                        <span>{`${t('commentSupBuy')} : ${(i?.saleComment && i?.saleComment) || '-'}`}</span>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-1" onClick={toggle}>
          <Translate code="close" />
        </button>
      </ModalFooter>
    </Modal>
  );
};

HistoryModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  saleInfo: PropTypes.shape().isRequired,
  offers: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  dateFormat: PropTypes.string.isRequired,
};

const GroupListModel = ({ isOpen, toggle }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalBody className="pb-0">
      <div className="form-group text-Alert" data-cy="textAlertLogout">
        <span>{t('coverageRequestPopUpTitle')}</span>
      </div>
      <span>{t('coverageRequestPopUp')}</span>
    </ModalBody>
    <ModalFooter>
      <button type="button" className="btn btn-1" onClick={toggle}>
        <Translate code="close" />
      </button>
    </ModalFooter>
  </Modal>
);

GroupListModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
const AlcopaModal = ({ isOpen, toggle, handleCreate, cancelAlcopa }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalBody className="pb-0 text-center">
      <p>{t('confirmRoadTestAlcopa')}</p>
    </ModalBody>
    <ModalFooter className="justify-content-center">
      <button type="button" className="btn btn-3 mr-2" onClick={cancelAlcopa}>
        {t('cancel')}
      </button>
      <button
        type="button"
        className="btn btn-1"
        onClick={() => {
          toggle();
          handleCreate();
        }}
      >
        {t('confirm')}
      </button>
    </ModalFooter>
  </Modal>
);
AlcopaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  cancelAlcopa: PropTypes.func.isRequired,
};

const NoSelectedVersionAuctionnerModal = ({ isOpen, toggle, cancel }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalBody className="pb-0">
      <p>{t('popUpNoSelectedVersionAuctionner1')}</p>
      <p>{t('popUpNoSelectedVersionAuctionner2')}</p>
    </ModalBody>
    <ModalFooter className="justify-content-center">
      <button type="button" className="btn btn-3 mr-2" onClick={cancel}>
        {t('close')}
      </button>
    </ModalFooter>
  </Modal>
);
NoSelectedVersionAuctionnerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};
const InfoBullItem = ({ tooltipOpen, id, openInfoBull, message }) => (
  <>
    <FontAwesomeIcon icon={faInfoCircle} size="1x" id={id} className="info-icon" onClick={openInfoBull} />
    <Tooltip placement="bottom" isOpen={tooltipOpen} target={id} toggle={!isMobile && openInfoBull}>
      {t(message)}
    </Tooltip>
  </>
);

InfoBullItem.propTypes = {
  tooltipOpen: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  openInfoBull: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};
